import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Component/Header";
import { postTransferCertificate } from "../Service/Api";

const Tc = () => {
  useEffect(() => {
    document.title = "Transfer Certificate - Hill Top School, Jamshedpur";
  }, []);

  const navigate = useNavigate();

  const [admission, setAdmission] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const handleAdmissionNoChange = (e) => {
    setAdmission(e.target.value);
    setError("");
  };

  const handleFullNameChange = (e) => {
    setName(e.target.value);
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !admission) {
      setError("Please fill in all fields");
      return;
    }

    try {
      const response = await postTransferCertificate(name, admission);

      if (response?.data) {
        console.log("API Response:", response.data);

        // ✅ Build file URL (same pattern as your working reference may vary)
        const fileUrl = `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${response.data}`;

        // ✅ Direct download (most reliable for S3 public files)
        const a = document.createElement("a");
        a.href = fileUrl;
        a.target = "_blank";
        a.download = "transfer-certificate.jpg";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        setError("Invalid response from server");
      }
    } catch (err) {
      console.error("Error:", err);
      setError("Failed to process your request. Please try again later.");
    }
  };

  return (
    <>
      <Header />

      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>Transfer Certificate</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Transfer Certificate</h1>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="tcblock">
                <div className="tc">
                  <form onSubmit={handleSubmit}>
                    <div className="formfil">
                      {/* Admission No */}
                      <div className="form-group">
                        <label>
                          <p>Admission No.</p>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={admission}
                          onChange={handleAdmissionNoChange}
                        />
                      </div>

                      {/* Student Name */}
                      <div className="form-group">
                        <label>
                          <p>Student Full Name</p>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={name}
                          onChange={handleFullNameChange}
                        />
                      </div>
                    </div>

                    <div className="clr30"></div>

                    {error && (
                      <p style={{ color: "red", marginBottom: "10px" }}>
                        {error}
                      </p>
                    )}

                    <input
                      type="submit"
                      className="viewdetailsbtn"
                      value="Submit"
                    />
                  </form>
                </div>

                <iframe
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/HTSJ/public/pdf/TC-Sample.pdf#toolbar=0"
                  width="100%"
                  height="500"
                  title="TC Sample"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tc;